"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { createRef, Component } from "react";
import classNames from "classnames";
import { handleMouseUpByBlurring } from "../../../utils/focus";
import { TabsContext } from "./Tabs";
var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);
  var _super = _createSuper(Tab);
  function Tab() {
    var _this;
    _classCallCheck(this, Tab);
    _this = _super.apply(this, arguments);
    _this.tabRef = createRef();
    return _this;
  }
  _createClass(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.addTabRef(this.tabRef, this.props.index);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeTabRef(this.tabRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        index = _this$props.index,
        children = _this$props.children,
        className = _this$props.className,
        onClick = _this$props.onClick;
      var _this$context = this.context,
        selectedIndex = _this$context.selectedIndex,
        setSelectedIndex = _this$context.setSelectedIndex,
        id = _this$context.id;
      var isSelected = selectedIndex === this.props.index;
      var handleClick = function handleClick(event) {
        onClick == null ? void 0 : onClick(event);
        setSelectedIndex(index);
      };
      return /* @__PURE__ */React.createElement("button", {
        className: classNames("tabs__tab", className),
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": "tabs-".concat(id, "-panel-").concat(index),
        id: "tabs-".concat(id, "-tab-").concat(index),
        onClick: handleClick,
        onMouseUp: handleMouseUpByBlurring,
        tabIndex: isSelected ? 0 : -1,
        ref: this.tabRef,
        type: "button"
      }, children);
    }
  }]);
  return Tab;
}(Component);
Tab.contextType = TabsContext;
export default Tab;